/* The portal's shell at three widths. full: sidebar + page · compact: top bar + page · narrow: phone with
   top bar and bottom menu. The page content is passed in and laid out by the same mode. `bare` = the page fills
   the work surface itself (the AI workspace). */
import "./showcase.css";
import { BottomNav, Sidebar, TopBar } from "./ui";
import { cn } from "@/lib/utils";

export const Shell = ({ mode = "full", active, children, overlay, bare = false, className }) => {
  const pad = bare ? "" : mode === "full" ? "px-8 py-8" : mode === "compact" ? "px-6 py-6" : "px-4 py-5";
  return (
    <div className={cn("hh", className)} data-mode={mode} data-view={active}>
      <div className="flex h-full w-full">
        {mode === "full" ? <Sidebar active={active} /> : null}
        <div className="relative flex min-w-0 flex-1 flex-col">
          {mode !== "full" ? <TopBar mode={mode} /> : null}
          <div className={cn("min-h-0 min-w-0 flex-1", pad, mode === "narrow" && !bare && "pb-20", bare && mode === "narrow" && "pb-16")}>{children}</div>
          {mode === "narrow" ? <BottomNav active={active} /> : null}
        </div>
      </div>
      {overlay}
    </div>
  );
};
